import { Container, Logo } from './styles'

const Titulo = () => (
  <Container>
    <Logo src="logo.png" alt="Logo" />
  </Container>
)

export default Titulo
